import {
  GET_ACCOUNT_DETAILS,
  UPDATE_ACCOUNT_DETAILS_PAYMENT_INFO,
} from './types'

// API
import * as API from '../utils/api';

// Get Account Details and Add them to Redux
export const getProfileAccountDetails = (user, athleteUsername) => dispatch => {
  return new Promise((resolve, reject) => {
    API.getProfileLevelAccountInfo(user, athleteUsername)
      .then(response => {
        if (response.errors) {
          reject('Error')
        } else {
          let responseObject = {
            success: true
          }

          dispatch(receiveAccountDetails(response))
          resolve(responseObject)
        }
      }).catch(error => {
        console.log('there was an error: ', error);
      });
  });
}

const receiveAccountDetails = (details) => ({
  type: GET_ACCOUNT_DETAILS,
  details
});

// Get Account Details and Add them to Redux
export const updateAccountDetailsPaymentInfo = (details) => dispatch => {
  return new Promise((resolve, reject) => {
    let responseObject = {
      success: true
    }

    dispatch(receiveUpdatedPaymentInfo(details))
    resolve(responseObject)
  });
}

export const receiveUpdatedPaymentInfo = (details) => ({
  type: UPDATE_ACCOUNT_DETAILS_PAYMENT_INFO,
  details
});



// WEBPACK FOOTER //
// ./src/actions/accountDetails.js